import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=928bd40c"
import script from "./CatalogSearch.vue?vue&type=script&lang=js"
export * from "./CatalogSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports